export default "__VITE_ASSET__C9PP82fn__"